module.exports = __webpack_public_path__ + "img/logo.0059e934.png";